import React, { Component } from "react";
import { Grid } from "semantic-ui-react";

import TimetableControls from "./TimetableControls";
import TimetableTitle from "./TimetableTitle";
import TimetableView from "./TimetableView";

import { TimetableRequest, TimetableType } from "../../../api/Timetable";

/**
 * AgendaTimetable : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Timetable component which renders a user's timetable
 * and acts as a controller
 */
class AgendaTimetable extends Component {
  /**
   * state: Object
   * Current state of the component
   */
  state = {
    /**
     * currentWeek: Integer
     * Number of weeks offset from current week
     */
    currentWeek: 0,
    /**
     * currentTimetable: String
     * Holds a string with the current timetable data
     */
    currentTimetable: "",
    /**
     * isLoading: Boolean
     * True if a timetable request is currently ongoing
     */
    isLoading: false
  };

  componentDidMount() {
    this.autoSetWeek();
  }

  /**
   * Selects a specific week and fetches the timetable
   * @param {*} week
   */
  selectWeek(week) {
    this.setState(
      {
        currentWeek: week
      },
      () => this.fetchTimetable()
    );
  }

  /**
   * Automatically sets the current week based on
   * the current date
   */
  autoSetWeek = () => {
    if (this.isOutlook()) {
      this.selectWeek(1);
      return;
    }
    this.selectWeek(0);
  };

  /**
   * Returns true if today is Saturday or Sunday
   */
  isOutlook = () => {
    const now = new Date();
    return now.getDay() === 6 || now.getDay() === 0;
  };

  /**
   * Increments the current week by 1 and loads the timetable.
   */
  nextWeek() {
    this.selectWeek(this.state.currentWeek + 1);
  }
  /**
   * Decrements the current week by 1 and loads the timetable.
   */
  prevWeek() {
    this.selectWeek(this.state.currentWeek - 1);
  }

  /**
   * Dispatches a timetable request and loads the timetable
   * for the currently selected week and class.
   */
  fetchTimetable = () => {
    const identifier = 2226;
    const request = new TimetableRequest(TimetableType.CLASS, identifier);

    this.setState({
      isLoading: true
    });

    request.setWeek(this.state.currentWeek);
    request.fetch(response =>
      this.setState({
        currentTimetable: response,
        isLoading: false
      })
    );
  };

  render() {
    return (
      <div className="ag-timetable">
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <TimetableTitle currentWeek={this.state.currentWeek} />
            </Grid.Column>
            <Grid.Column width={8}>
              <TimetableControls
                onNextWeek={() => this.nextWeek()}
                onPrevWeek={() => this.prevWeek()}
                isLoading={this.state.isLoading}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <TimetableView currentTimetable={this.state.currentTimetable} />
      </div>
    );
  }
}

export default AgendaTimetable;



// WEBPACK FOOTER //
// ./src/modules/agenda/timetable/AgendaTimetable.js